const { href } = window.location
export const prod = !href.includes('localhost') && !href.includes('192.168')